import store from '../store/store';
import types from '../store/types';

declare var jQuery;

export class DOMHelper {

	static setDropdownPropertyTabIndex = () => {

        //remove the tab index from property drop downs
        let dropdownWrappers = document.querySelectorAll('.dropdown-wrapper');
        for(let i = 0; i < dropdownWrappers.length; i++) {
            let dropdownWrapper: HTMLElement = <HTMLElement>dropdownWrappers[i];
			let dropdown = dropdownWrapper.querySelector('.ms-Dropdown');
			if(dropdown) {
				dropdown.setAttribute('tabindex', dropdownWrapper.getAttribute('data-tabindex'));
			}
        }		

	}

	/**
	 * Locates the first element within a modal that can be focussed on, and then focuses on it
	 * @returns true if a suitable element is found, false otherwise
	 */
	static focusOnFirstModalTabbableControl = (): boolean => {

		let selectors:string[] = ['.type-selector', '.ms-TextField-field', '.ms-Button', '.ms-Toggle-button', '.ms-Dropdown'];
		let selector = selectors.map((v) => {
			return '.ms-Dialog-content ' + v;
		}).join(',');

		let element = <HTMLElement>document.querySelector(selector);
		if(element) {
			setTimeout(() => { element.focus(); }, 10);
			return true;
		}
		
		return false;

	}

	static scrollToComponent = (componentId: string) => {

		//scroll to the component
		let componentElement = document.querySelector('.component[data-id="' + componentId + '"]');
		if(componentElement) {
			componentElement.scrollIntoView(true);
			//focus on the menu of that component
			let menuButton = <HTMLElement>componentElement.querySelector('button.action');
			if(menuButton) {
				menuButton.focus();
			}
		}

	}

	static setDialogHeight = () => {

		let dialogHeight = window.innerHeight - 30;
		jQuery(".ms-Dialog .ms-Dialog-main").css("max-height", dialogHeight + "px");

	}

}


// WEBPACK FOOTER //
// ./source/ts/helpers/dom.ts